var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIconCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 53C30.7837 53.0041 34.0357 52.3593 37.0694 51.1026C40.1031 49.846 42.8586 48.0023 45.1775 45.6775C47.5023 43.3586 49.346 40.6031 50.6026 37.5694C51.8593 34.5357 52.5041 31.2837 52.5 28C52.5041 24.7164 51.8593 21.4643 50.6026 18.4306C49.346 15.397 47.5023 12.6415 45.1775 10.3225C42.8586 7.99772 40.1031 6.15404 37.0694 4.89741C34.0357 3.64078 30.7837 2.99597 27.5 3.00002C24.2164 2.99597 20.9643 3.64078 17.9306 4.89741C14.897 6.15404 12.1415 7.99772 9.82252 10.3225C7.49772 12.6415 5.65404 15.397 4.39741 18.4306C3.14078 21.4643 2.49597 24.7164 2.50002 28C2.49597 31.2837 3.14078 34.5357 4.39741 37.5694C5.65404 40.6031 7.49772 43.3586 9.82252 45.6775C12.1415 48.0023 14.897 49.846 17.9306 51.1026C20.9643 52.3593 24.2164 53.0041 27.5 53Z",
    stroke: "#DA0D29",
    strokeWidth: 4.67,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 28L25 35.5L40 20.5",
    stroke: "#DA0D29",
    strokeWidth: 4.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconCircle);
export default __webpack_public_path__ + "static/media/check-icon-circle.828af5f952f87b20be9f4433a966d410.svg";
export { ForwardRef as ReactComponent };